import { NgModule } from '@angular/core';

import { HisFileUploadSharedModule } from './his-file-upload-shared.module';

/**
 * The core module for the generic search.
 */
@NgModule( {
    imports: [
        HisFileUploadSharedModule,
    ],
    declarations: [
    ],
    exports: [
        HisFileUploadSharedModule,
    ]
} )

export class HisFileUploadCoreModule {

}
